export const ERROR_UNEXPECTED = 'ERROR_UNEXPECTED';
export const ERROR_PARTNERS_INITIATE = 'PARTNERS_INITIATE';
export const ERROR_PARTNERS_CONNECTIONS = 'PARTNERS_CONNECTIONS';
export const ERROR_PARTNERS_VALIDATE_CODE = 'PARTNERS_VALIDATE_CODE';
export const ERROR_PARTNERS_ACCEPT_CONSENT = 'PARTNERS_ACCEPT_CONSENT';
export const ERROR_PARTNERS_DECLINE_CONSENT = 'PARTNERS_DECLINE_CONSENT';
